import { Controller } from "@hotwired/stimulus"

// ⌘K: opens the search dialog, reloads its results frame as the query
// changes, and lets ↑ ↓ pick a result and Enter open it.
export default class extends Controller {
  static targets = ["dialog", "input", "frame"]
  static values = { url: String }

  connect() {
    this.onKey = this.onKey.bind(this)
    document.addEventListener("keydown", this.onKey)
  }

  disconnect() {
    document.removeEventListener("keydown", this.onKey)
  }

  onKey(event) {
    if ((event.metaKey || event.ctrlKey) && event.key.toLowerCase() === "k") {
      event.preventDefault()
      this.dialogTarget.open ? this.close() : this.open()
    }
  }

  open() {
    this.inputTarget.value = ""
    this.load("")
    this.dialogTarget.showModal()
    this.inputTarget.focus()
  }

  close() {
    this.dialogTarget.close()
  }

  backdrop(event) {
    if (event.target === this.dialogTarget) this.close()
  }

  search() {
    clearTimeout(this.timer)
    this.timer = setTimeout(() => this.load(this.inputTarget.value), 150)
  }

  load(query) {
    const url = new URL(this.urlValue, window.location.origin)

    url.searchParams.set("q", query)
    this.frameTarget.src = url.toString()
  }

  navigate(event) {
    const items = [...this.frameTarget.querySelectorAll("[data-palette-item]")]
    const current = items.findIndex((item) => item.getAttribute("aria-selected") === "true")

    if (event.key === "Enter") {
      event.preventDefault()
      items[current]?.click()

      return
    }

    if (event.key !== "ArrowDown" && event.key !== "ArrowUp") return

    event.preventDefault()

    if (items.length === 0) return

    const step = event.key === "ArrowDown" ? 1 : -1
    const next = (current + step + items.length) % items.length

    items.forEach((item, index) => item.setAttribute("aria-selected", String(index === next)))
    items[next].scrollIntoView({ block: "nearest" })
  }
}
